import React from 'react'
import { ControlLayout } from './ControlLayout'
import PropTypes from 'prop-types'
import { Field } from 'redux-form'
// import InputNumber from 'antd/lib/input-number'
import styles from './MoneyBox.less'

import { sh, ah, compose, ReduxWrapper } from 'common-data/datahelpers'

import { buildState } from 'common-data/statehelpers'

class MoneyBoxClass extends React.Component {
  constructor (props) {
    super(props)

    const { SessionUser } = props
    let currencySymbol = '?'

    if (SessionUser) {
      currencySymbol = SessionUser.CurrencyFormat.Symbol
    }

    this.state = {
      currencySymbol: currencySymbol
    }
  }
  static propTypes = {
    ColSize: PropTypes.number,
    precision: PropTypes.number,
    step: PropTypes.number,
    input: PropTypes.shape({
      name: PropTypes.string,
      onChange: PropTypes.func,
      value: PropTypes.any
    })
  }

  static defaultProps = {
    ColSize: 0,
    precision: 2,
    step: 0.25
  }

  render () {
    const { input: { value, onChange, name }, precision, step } = this.props
    // const { currencySymbol } = this.state

    return (
      <ControlLayout WrappedCtrl={this.props}>
        <input id={`money${name}`} value={value} type="number"
          onChange={onChange} className={styles.money}
          pattern="^-?[0-9]\d*\.?\d*$"
          name="ticketNum" list="defaultNumbers"/>
        <span className="validity"></span>
        {/* <InputNumber
          className={styles.money}
          id={`money${name}`}
          defaultValue={0}
          value={value}
          // formatter={value => `${currencySymbol} ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
          // formatter={value => `${currencySymbol}${value}`}
          // parser={value => value.replace(/\$\s?|(,*)/g, '')}
          // parser={value => value.replace(currencySymbol, '')}
          // formatter={value => `${currencySymbol} ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
          // parser={value => value.replace(/\p{S}\s?|(,*)/g, '')}
          onChange={onChange}
          precision={precision || 2}
          step={step || 0.25}
        /> */}
      </ControlLayout>
    )
  }
};
export const MoneyBoxWrap = compose(
  ReduxWrapper([
    sh.SessionToken,
    sh.SessionAccount
  ], [
    ah.addLayoutBreadCrumbKey
  ])
)(MoneyBoxClass)

export const MoneyBox = (props) => { return <Field name={props.name} {...props} component={MoneyBoxWrap} /> } // eslint-disable-line
export default MoneyBox
